











import Group from '@/types/Group.interface'
import GroupQueryForm from '@/components/GroupQueryForm.vue'
import GroupStaticForm from '@/components/GroupStaticForm.vue'
import Vue from 'vue'
export default Vue.extend({
    components: { GroupQueryForm, GroupStaticForm },
    props: ['id'],
    data() {
        return {
            loading: false,
            //  Determines if we have finished loading everything
            mounted: false,
            //  Our group bound to this form
            selectedGroup: null
        }
    },
    async mounted() {
        //  Check if a group is set in the url params
        const id = this.id

        //  If a group id is set, load it
        if (id) {
            //  Start loading
            this.loading = true

            //  Set our group
            this.selectedGroup = await this.$store.dispatch('groupsFind', id)

            //  Stop loading
            this.loading = false
        }

        //  We use this mounted variable to track when dom elements have been rendered
        this.mounted = true
    },
    computed: {
        toolbar(): object {
            //  If a group does NOT exist, return empty object (so toolbar fills its space)
            if (!this.selectedGroup) return {}

            //  Else, get group attributes
            const type = this.$options.filters.groupType(this.selectedGroup)
            const icon = this.$options.filters.groupIcon(this.selectedGroup)

            //  Return parse toolbar bar title
            return {
                title: this.selectedGroup.name,
                subtitle: `<span class="mdi ${icon}"/><span class="ml-1">${type}</span>`
            }
        }
    },
    methods: {
        async groupUpdate(group: Group): Promise<void> {
            //  Disable the group form
            this.loading = true

            //  Send the request to the api
            const response = await this.$store.dispatch('groupsPut', group)

            //  Enable the forms
            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            //  Clear the query form
            if (this.$refs.queryForm) this.$refs.queryForm.clearForm()

            //  Navigate to the updated group
            this.$router.push(`/groups/${group.id}`)

            //  Else, notify the user of successful response
            this.$store.commit('appNotificationBarSet', {
                message: 'Group Updated'
            })
        }
    }
})
